import React from "react";
import { Button, DropdownButton } from "../Button";

import bloodCenterQuery from "../../utils/queries/bloodCenterQuery";
import { Loading } from "../Loader";
import icons from "../../constants/icons";
import { CardHeader } from "../Header";
import { connect } from "react-redux";
import language from "../../language";
import { Checkbox } from "../Input";

let copyData = [];

class CentersFilter extends React.Component {
  state = {
    isLoading: true,
    data: [],
    page: 1,
    limit: 50,
    centers: [],
  };

  componentDidMount = async () => {
    await this.getData(true);
  };

  componentDidUpdate = async (prevProps) => {
    if (prevProps.categoryType !== this.props.categoryType) {
      await this.getData(true);
    }
  };

  getData = async (isLoading) => {
    try {
      const { defaultLanguage } = this.props;
      const { page, limit } = this.state;

      this.setState({ isLoading });

      const data = await bloodCenterQuery(defaultLanguage, {
        page,
        limit,
        type: "dropdown",
      });

      this.setState({
        data: data,
        isLoading: false,
      });

      copyData = data.slice(0);
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  onCheck = async (el) => {
    const centers = this.state.centers || [];
    const exists = centers.some((sEl) => sEl.value === el._id);
    const nextCenters = exists
      ? centers.filter((sEl) => sEl.value !== el._id)
      : [...centers, { value: el._id, label: el.name }];

    // await this.props.dispatch(
    //   onAddFilter({
    //     centers,
    //   })
    // );
    this.setState({ centers: nextCenters });

    this.props.handleApplyFilters &&
      this.props.handleApplyFilters(true, { centers: nextCenters });
  };

  async handleSearch(e) {
    const searchValue = e?.target?.value;
    this.setState({ searchValue });

    const searchText = (searchValue || "").trim().toLowerCase();

    if (!searchText) {
      this.setState({ data: copyData.slice(0) });
      return;
    }

    let results = [];
    copyData.forEach((el) => {
      if (
        JSON.stringify(el).toLowerCase().indexOf(searchText) !== -1
      ) {
        results.push(el);
      }
    });

    if (results.length > 0) {
      this.setState({ data: results });
      return;
    }

    // Fallback to remote search when local cache has no matches.
    try {
      const { defaultLanguage } = this.props;
      const remoteData = await bloodCenterQuery(defaultLanguage, {
        page: 1,
        limit: 10000,
        type: "dropdown",
        q: searchValue,
      });

      this.setState({ data: remoteData || [] });
    } catch (error) {
      this.setState({ data: [] });
    }
  }

  onReset() {
    this.setState({ centers: [] });
    this.props.handleApplyFilters &&
      this.props.handleApplyFilters(true, { centers: [] });
  }

  render() {
    const selectedCenterLabels = (this.state?.centers || [])
      .map((el) => el?.label)
      .filter(Boolean);

    const centerButtonText =
      selectedCenterLabels.length > 0
        ? `${language[this.props.defaultLanguage].filter_centers}: ${selectedCenterLabels.join(", ")}`
        : language[this.props.defaultLanguage].filter_centers;

    return (
      <DropdownButton
        leftIcon={icons.center}
        text={centerButtonText}
        className="btn-transparent btn-bordered w-sm-100 btn-sm"
        selectedData={this.state?.centers}
        clickOutside
        disabled={this.props.disabled}
      >
        <CardHeader
          title={language[this.props.defaultLanguage].filter_centers}
          borderBottom
          closeButton
          isSearch
          searchValue={this.state.searchValue}
          handleSearch={(e) => this.handleSearch(e)}
        />
        <div className="card-body">
          <Button
            text={language[this.props.defaultLanguage].reset}
            onPress={this.onReset.bind(this)}
          />
        </div>
        <div className="dropdown-content">
          {this.state.isLoading ? (
            <center>
              <Loading />
            </center>
          ) : (
            this.state?.data?.map((el, i) => {
              return (
                <Checkbox
                  label={el.name}
                  key={i}
                  onCheck={() => this.onCheck(el)}
                  checked={this.state?.centers?.find(
                    (sEl) => sEl.value === el._id
                  )}
                />
              );
            })
          )}
        </div>
      </DropdownButton>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(CentersFilter);
